import type { Theme } from '@mui/material';

import { brandBackground } from 'src/theme/brandBackground';

export const styles = {
  header: (theme: Theme) => ({
    background: brandBackground(theme),
    height: theme.dimension.headerHeight.xs,

    [theme.breakpoints.up('lg')]: {
      height: theme.dimension.headerHeight.lg,
      padding: '1rem 2rem 0',
    },
  }),

  headerContainer: {
    height: '100%',
    justifyContent: 'space-between',
  },

  surveyLogo: (theme: Theme) => ({
    height: '100%',
    maxHeight: '4.5rem',
    marginBottom: theme.spacing(1),
    display: 'flex',
    justifyContent: 'center',
  }),

  headerBanner: (theme: Theme) => ({
    height: '65%',
    pb: 1,
    color: theme.colors.secondary[800],

    '> *': {
      height: '100%',
    },
  }),

  headerNavigation: {
    height: '35%',
    justifyContent: 'space-between',
    alignItems: 'flex-end',

    '> *': {
      marginTop: 'auto',
    },
  },

  headerTop: (theme: Theme) => ({
    justifyContent: 'space-between',

    [theme.breakpoints.up('lg')]: {
      paddingY: 0.5,
    },
  }),

  guidedTourButton: (theme: Theme) => ({
    bgcolor: theme.colors.secondary[50],
    color: theme.colors.secondary[800],

    svg: {
      color: theme.colors.secondary[800],
    },

    '&:disabled': {
      bgcolor: theme.colors.secondary[200],
      color: theme.colors.secondary[600],

      svg: {
        color: theme.colors.secondary[600],
      },
    },

    '&:hover:not(:disabled)': {
      bgcolor: theme.colors.secondary[50],
    },
  }),
};
